import React from 'react';
import {
  Datagrid,
  DeleteButton,
  Edit,
  EditButton,
  Filter,
  TextField,
  TextInput,
  ReferenceField,
  ChipField,
  ReferenceInput,
  SelectInput,
} from 'react-admin';
import HNList from '../components/HNList';
import HNForm from '../components/HNForm';

const MgSubscriptionFilter = (props: any) => (
  <Filter {...props}>
    <TextInput style={{ minWidth: '300px' }} source="search" label="Search" alwaysOn />
  </Filter>
);

export const MgSubscriptionList: React.FC<any> = (props) => {
  return (
    <HNList {...props} filters={<MgSubscriptionFilter />}>
      <Datagrid>
        <TextField source="name" label="Name" emptyText="-" />
        <TextField source="sku" label="SKU" emptyText="-" />
        <ReferenceField reference="access" source="access_id" label="Access">
          <ChipField source="name" />
        </ReferenceField>
        <EditButton />
        <DeleteButton />
      </Datagrid>
    </HNList>
  );
};

const MgSubscriptionTitle: React.FC<any> = ({ record }) => (
  <span>{record && `Magento Subscription "${record.id}"`}</span>
);
export const MgSubscriptionEdit: React.FC<any> = (props) => (
  <Edit title={<MgSubscriptionTitle />} {...props}>
    <HNForm {...props}>
      <TextInput source="id" disabled />
      <TextInput source="name" />
      <TextInput source="sku" />
      <ReferenceInput label="Access" source="access_id" reference="access" perPage={10000}>
        <SelectInput optionText="name" />
      </ReferenceInput>
    </HNForm>
  </Edit>
);
